module.exports = __webpack_public_path__ + "static/media/13.14533f0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/13.jpg
// module id = 576
// module chunks = 0